module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/kw-a3a60802b9df1ea679acbbebbc926483.svg";